// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/no-array-index-key, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, react/prop-types */
import React from "react"
import { connect } from "react-redux"
import { hideModal } from "@kiwicom/frontend-common/services/modals/actions"

import { smartFill, testUsers } from "../../tools/smartFill"

const SmartFillOptionsList = (props) => (
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line react/jsx-filename-extension
  <div className="spCard spShadow-half">
    <h4>Test users for smart fill</h4>
    <ul>
      {testUsers.map((item, index) => (
        <li className="DebugModal-smart-fill-user-item" key={index}>
          <span onClick={() => props.doSmartFill(item)}>{item.email}</span>
        </li>
      ))}
    </ul>
  </div>
)

export default connect(null, (dispatch) => ({
  doSmartFill: (user) => {
    smartFill(user)
    dispatch(hideModal("debug"))
  },
}))(SmartFillOptionsList)
